var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnvelope = function SvgIconEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 5.25a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V18a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18zm3.57 1L12 12.143l6.43-5.893zM20 7.523l-4.882 4.475L20 16.475zM18.43 17.75H5.57l4.792-4.395.962.882a1 1 0 0 0 1.352 0l.962-.882zm-9.548-5.752L4 7.523v8.952z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEnvelope;